// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const IMPERSONATE = 'IMPERSONATE';
export const EXIT_IMPERSONATION = 'EXIT_IMPERSONATION';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
